/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import PropTypes from 'prop-types';

/**layout */
import SubLayout from '../../layouts/components/subLayout/SubLayout';

const Acquisitions = (WrappedComponent) => {
  
  const ChildComponent = (props) => (

    <SubLayout>
      <WrappedComponent {...props} />
    </SubLayout>
  );

  return ChildComponent;
}

Acquisitions.propTypes = {
  WrappedComponent: PropTypes.elementType.isRequired,
};

export default Acquisitions